export enum ActiveToken {
  None = -1,
  Primary,
  Proxy
}
